// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserMessage{box-sizing:border-box}.UserMessage__PmBadge{margin-right:4px;vertical-align:text-bottom}.UserMessage__UsernameContainer{margin-right:6px}.UserMessage__Media{margin-top:4px}#MobileBroadcastRoot .ChatMediaCarousel{box-shadow:0px 0px 32px rgba(0,0,0,.32);background:#202c39}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
